import { Directive, HostListener, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { parsePhoneNumber } from 'awesome-phonenumber';

@Directive({
  selector: '[espPhoneNumberFormat]',
  standalone: true,
})
export class EspPhoneNumberFormatDirective {
  private _control = inject(NgControl);

  countryCode = input('');

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    const parsed = parsePhoneNumber(input.value, {
      regionCode: this.countryCode(),
    });

    if (parsed.valid) {
      this._control.control?.setValue(parsed.number.national);
    }
  }
}
